import React, {useState} from 'react';
import {FormattedMessage} from 'react-intl';
import {usePopupCreatePaymentLinkContext} from '../PopupCreatePaymentLinkContext';
import {StyledFieldInput} from '../../../_common/components/FieldInput';
import {StyledFieldSelect} from '../../../_common/components/FieldSelect';
import {filterOptions} from '../../../_common/utils/options';
import {formatStringToFloatNumber} from '../../../_common/utils/changeInputValue';
import ButtonAction from '../../../_common/components/ButtonAction';
import ModalContainer from '../../../_common/components/ModalContainer';
import ModalHeader from '../../../_common/components/ModalHeader';
import ModalButtonsContainer from '../../../_common/components/ModalButtonsContainer';
import ModalContent from '../../../_common/components/ModalContent';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../../_common/styles/styles';
import {maxPayments, docTypes} from '../../../_common/constants/options';

const PopupCreatePaymentLink = ({}) => {
  const {
    formik: {
      values,
      isValid,
      setFieldValue,
      errors
    },
    handleSubmit,
    hasPluginID
  } = usePopupCreatePaymentLinkContext();
  const [show, setShow] = useState(false);
  const handleShowModal = () => setShow(true);
  const handleCloseModal = () => setShow(false);
  const commonContainerStyles = 'py-3';
  const prefix = 'customer-details-popup-payment';

  return hasPluginID && (
    <>
      <ButtonAction
        variant={'success'}
        useIcon={'/media/common/Link_white.svg'}
        label={
          <FormattedMessage
            id="customer-details-documentInfo-label-button-generate-payment-link"
            defaultMessage="Create a link for payment"
          />
        }
        onClick={handleShowModal}
      />
      <ModalContainer show={show} onHide={handleCloseModal} size={'md'}>
        <ModalHeader header={<FormattedMessage id={`${prefix}-header`} defaultMessage="Create a link for payment"/>}/>
        <ModalContent customClassnames={'bg-transparent'}>
          <StyledFieldInput
            fieldId={'description'}
            value={values.description}
            onChange={(e) => setFieldValue('description', e.target.value)}
            label={
              <div>
                <FormattedMessage id={`${prefix}-form-label-description`} defaultMessage="Description"/>
                <span className={'text-danger'}>*</span>
              </div>
            }
            customContainerStyles={commonContainerStyles}
          />
          <StyledFieldInput
            fieldId={'amount'}
            value={values.amount}
            onChange={(e) => {
              setFieldValue('amount', formatStringToFloatNumber(e));
            }}
            label={
              <div>
                <FormattedMessage id={`${prefix}-form-label-amount`} defaultMessage="Amount"/>
                <span className={'text-danger'}>*</span>
              </div>
            }
            customContainerStyles={commonContainerStyles}
          />
          <StyledFieldInput
            fieldId={'remarks'}
            value={values.remarks}
            onChange={(e) => setFieldValue('remarks', e.target.value)}
            label={<FormattedMessage id={`${prefix}-form-label-remarks`} defaultMessage="Remarks"/>}
            customContainerStyles={commonContainerStyles}
          />
          <StyledFieldSelect
            fieldId={'maxPayments'}
            onChange={(option) => setFieldValue('maxPayments', option.value)}
            value={filterOptions(values.maxPayments)(maxPayments)}
            options={maxPayments}
            label={
              <div>
                <FormattedMessage id={`${prefix}-form-label-maxPayments`} defaultMessage="Max payments"/>
                <span className={'text-danger'}>*</span>
              </div>
            }
            customContainerStyles={commonContainerStyles}
          />
          <StyledFieldSelect
            fieldId={'type'}
            onChange={(option) => setFieldValue('type', option.value)}
            value={filterOptions(values.type)(docTypes)}
            options={docTypes}
            label={
              <div>
                <FormattedMessage id={`${prefix}-form-label-docType`} defaultMessage="Doc type"/>
                <span className={'text-danger'}>*</span>
              </div>
            }
            customContainerStyles={commonContainerStyles}
          />
          <div className={'position-relative pb-2'}>
            <StyledFieldInput
              fieldId={'email'}
              type={'email'}
              value={values.email}
              onChange={(e) => setFieldValue('email', e.target.value)}
              label={
                <div>
                  <FormattedMessage id={`${prefix}-form-label-email`} defaultMessage="Email"/>
                  <span className={'text-danger'}>*</span>
                </div>
              }
              customContainerStyles={commonContainerStyles}
            />
            {errors.email === 'Invalid email address!' && (
              <div className={'text-danger font-weight-bold position-absolute bottom-0 pl-6'}>
                <FormattedMessage id="invalid-email-message" defaultMessage="Invalid email"/>
              </div>
            )}
          </div>
        </ModalContent>
        <ModalButtonsContainer customClassnames={largeButtonsPadding}>
          <ButtonAction
            variant={'cancel'}
            onClick={handleCloseModal}
            label={<FormattedMessage id={`${prefix}-link-button-label-cancel`} defaultMessage="Cancel"/>}
            customClassnames={buttonCancel}
          />
          <ButtonAction
            onClick={() => handleSubmit(values)}
            disabled={!(isValid && hasPluginID)}
            useIcon={'/media/common/Check-in-circle_white.svg'}
            label={<FormattedMessage id={`${prefix}-link-button-label-submit`} defaultMessage="Create"/>}
            customClassnames={buttonSubmit}
          />
        </ModalButtonsContainer>
      </ModalContainer>
    </>
  );
};

export default PopupCreatePaymentLink;